import { useTranslation } from 'react-i18next';
import { ArrowLeft, Phone } from '@phosphor-icons/react';

/* Round call control with a readable label underneath. */
export function CallControl({ label, className = '', children, ...rest }) {
  return (
    <span className="jp-call-ctl">
      <button type="button" aria-label={label} title={label} className={`jp-call-btn ${className}`} {...rest}>{children}</button>
      <span className="jp-call-ctl-label">{label}</span>
    </span>
  );
}

/* Back to the conversation without hanging up (the call keeps running). */
export function CallBackButton({ onClick, testId = 'call-back-btn' }) {
  const { t } = useTranslation();
  if (!onClick) return <span />;
  return (
    <button type="button" onClick={onClick} data-testid={testId} className="jp-call-back" aria-label={t('web.call_back')}>
      <ArrowLeft size={18} weight="bold" /><span>{t('web.call_back')}</span>
    </button>
  );
}

export function CallReturnPill({ label, onReturn }) {
  const { t } = useTranslation();
  return (
    <button type="button" onClick={onReturn} data-testid="call-return-pill" className="jp-call-return-pill">
      <span className="jp-rec-dot" style={{ background: '#22C55E' }} /><Phone size={16} weight="fill" />
      <span className="truncate">{label}</span><strong>{t('web.call_return')}</strong>
    </button>
  );
}
